import { h } from 'vue';
export default {
  components: {
    'load-js': {
      render() {
        return h('script', {
          type: 'text/javascript',
          src: this.src,
          onload: function () {
            console.log('load js finish');
          }
        });
      },
      props: {
        src: {
          type: String,
          required: true
        }
      }
    }
  },
  props: {
    src: {
      type: String
    }
  }
};